module.exports = __webpack_public_path__ + "media/images/emblems/Wagenhausen(Turgovio)-Blazono-e9b346fd8dd51f62b30bb98c133997b0.png";